"use client";
import { useState, useRef, useEffect, Suspense } from "react";
import { Stack, Typography } from "@mui/material";

import { observer, useStore } from "../../../../service/mobx";
import { entityMap } from "../../../../component/Search/Hooks";

function Top100({ type }) {
  const [page, setPage] = useState(1);
  const { search, user, utilities } = useStore();
  const {
    entityName,
    label,
    Card: [, Card]
  } = entityMap[type] ?? {};
  const count = search.count[label];
  const displayedItems = search.results.slice(0, 10 * page);
  const loading =
    user.loaded === false ||
    search.loadingResults ||
    (search.filterStars !== undefined && search.loadingStars);

  return (
    <>
      <Typography
        component="p"
        mb={1}
        variant="titleSm"
        color="var(--surface-on-color)"
      >
        {loading
          ? "Loading..."
          : count
          ? `Showing ${search.results.length}${
              search.loadingCount ? "" : ` of ${utilities.formatNumber(count)}`
            }`
          : undefined}
      </Typography>
      {search.results.length === 0 && loading === false ? (
        <Typography
          component="p"
          typography={{ compact: "titleMd", expanded: "headlineSm" }}
        >
          {`No results for ${
            search.userInput ? `"${search.userInput}"` : "these filters"
          }. Try changing your filters and query`}
        </Typography>
      ) : (
        <Stack useFlexGap spacing={1}>
          <Suspense>
            {displayedItems.map(result => (
              <Card key={result.id} {...{ [entityName]: result }} />
            ))}
          </Suspense>
          {loading || search.results.length === displayedItems.length ? null : (
            <LoadNextPage setPage={setPage} />
          )}
          {/* <ScrollBackToTop /> */}
        </Stack>
      )}
    </>
  );
}

export default observer(Top100);

function LoadNextPage({ setPage }) {
  const observerRef = useRef();

  useEffect(() => {
    if (observerRef.current) {
      const element = observerRef.current;
      const observer = new IntersectionObserver(
        ([{ isIntersecting }]) => {
          // If the observed entry is intersecting, increment the page number
          if (isIntersecting) {
            setPage(prevPage => prevPage + 1);
          }
        },
        { threshold: 0.5 } // Adjust threshold as needed
      );

      observer.observe(element);

      return () => observer.unobserve(element);
    }
  }, [setPage]);

  return (
    <Typography ref={observerRef} variant="bodyLg">
      Loading more items...
    </Typography>
  );
}
// function ScrollBackToTop() {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const toggleVisibility = () =>
//       setIsVisible(window.scrollY > window.innerHeight);

//     window.addEventListener("scroll", toggleVisibility);

//     return () => {
//       window.removeEventListener("scroll", toggleVisibility);
//     };
//   }, []);

//   return (
//     <Grow mountOnEnter unmountOnExit in={isVisible}>
//       <Fab
//         onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//         sx={theme => ({
//           position: "absolute",
//           bottom: 24,
//           right: 24,
//           width: { compact: 56, large: 96 },
//           height: { compact: 56, large: 96 },
//           bgcolor: "var(--primary-container)",
//           boxShadow: theme.elevation[3],
//           borderRadius: {
//             compact: "var(--shape-lg-round)",
//             large: "var(--shape-xl-round)"
//           },
//           transition: theme.transitions.create("all"),
//           "&:hover": {
//             bgcolor: "var(--primary-container)",
//             boxShadow: theme.elevation[4],
//             backgroundImage: `linear-gradient(${theme.addAlpha(
//               "var(--primary-on-container)",
//               0.08
//             )}, ${theme.addAlpha("var(--primary-on-container)", 0.08)}) !important`
//           }
//         })}
//       >
//         <ScrollUpArrow
//           sx={{
//             color: "var(--primary-on-container)",
//             width: { compact: 24, large: 36 },
//             height: { compact: 24, large: 36 }
//           }}
//         />
//       </Fab>
//     </Grow>
//   );
// }
